import Product from "containers/Product";
import ProductAccessories from 'containers/Product/product-accessories';
import ProductRTS from "containers/Product/product-rts";
import PropTypes from "prop-types";
import globalProps from "utils/globalProps";
import {
  PRODUCT_BY_HANDLE,
  productByHandleVars,
} from "helpers/graphql/product";
import client from "lib/shopify-storefront/client";
import Error from "components/Error";
import Loader from "components/Loader";
import { useRouter } from "next/router";
import { productView } from "lib/events/fb-pixel/product-view";
import { useEffect } from "react";
import Head from 'next/head';

import ContainedHead from "components/ContainedHead";
import { fixProductDataMetafields } from 'helpers/fixPriceObjectModel';
import Script from "next/script";

const P = ({ productData }) => {
  const { isFallback, asPath } = useRouter();
  if (isFallback) {
    return <Loader />;
  }
  if (
    productData === null ||
    productData.product === null ||
    productData?.product.tags.includes('custom')
  ) {
    return <Error code={404} />;
  }

  //useEffect(() => {
  //  productView(productData?.product);
  //}, []);

  useEffect(() => {
    const script = document.createElement('script');
    script.src = '/tripleWhale.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <>
      <Head>
        <link
          rel="preconnect dns-prefetch"
          href="https://triplewhale-pixel.web.app/"
          crossOrigin="true"
        />
        <link
          rel="preconnect dns-prefetch"
          href="https://api.config-security.com/"
          crossOrigin="true"
        />
        <meta property="og:image" content={productData.product.images.edges[0].node.transformedSrc} />
				<meta property="og:image:type" content="image/png"/>
				<meta property="og:image:width" content="1024"/>
				<meta property="og:image:height" content="1024"/> 
      </Head>
      <Script src="tripleWhale.js" dangerouslySetInnerHTML={{ __html: 'TripleHeadless = "aftershockpcsg.myshopify.com"'}} strategy="lazyOnload" />

      <ContainedHead
        title={
          productData?.product?.seo?.title != null
            ? productData?.product?.seo?.title
            : productData?.product?.title
        }
        description={
          productData?.product?.seo?.description ||
          productData?.product?.description
        }
        path={asPath}
      />

      {productData?.product?.productType &&
      productData?.product?.productType
        .replace(/ /g, '')
        .replace(/-/g, '')
        .toLowerCase() === 'readytoship' ? (
        <ProductRTS data={fixProductDataMetafields(productData)} />
      ) : productData?.product?.productType &&
        productData?.product?.productType.toLowerCase() === 'accessories' ? (
        <ProductAccessories data={fixProductDataMetafields(productData)} />
      ) : (
        <ProductAccessories data={fixProductDataMetafields(productData)} />
      )}
    </>
  );
};

P.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  productData: PropTypes.object,
};

export default P;

export async function getStaticProps({ params, preview = false }) {
  const {
    props: { global },
  } = await globalProps();
  const { handle } = params;

  const productHandle = handle?.join("-");
  const { data } = await client.query({
    query: PRODUCT_BY_HANDLE,
    variables: productByHandleVars(productHandle),
  });
  return {
    props: {
      productData: data,
      global,
    },
    revalidate: 1,
  };
}
export async function getStaticPaths() {
  return {
    paths: [],
    fallback: true,
  };
}
